
import React from 'react';
import { Helmet } from 'react-helmet-async';

const AdminOrderDetails: React.FC = () => {
  // Authentication is now handled by AdminRoute wrapper
  return (
    <>
      <Helmet>
        <title>Order Details - Admin</title>
      </Helmet>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8">Order Details</h1>
        <div className="bg-card rounded-lg p-6">
          <p className="text-muted-foreground">Order details will be available soon.</p>
        </div>
      </div>
    </>
  );
};

export default AdminOrderDetails;
